<template>
  <div class="info-box">
     <div class="info-box-summary">
      <div class="info-box-caption">Locations per hour (UTC)</div>
      <canvas show.bind="model" id="chart" ref="chartPlaceholder" width="420" height="150"></canvas>
      <div show.bind="!model" class="info-box-headline" title="loading" style="width: 420px; height: 150px;">
        <div class="info-box-spinner" style="padding-top: 55px;">
          <i class="fas fa-spinner sc-spin"></i>
        </div>
      </div>
    </div>
  </div>
</template>
